module.exports = __webpack_public_path__ + "static/img/2.996787b.png";


//////////////////
// WEBPACK FOOTER
// ./static/enterpriseEdition/5/2.png
// module id = Ogvs
// module chunks = 14